import { render, staticRenderFns } from "./MRC_ESS_Form_Sections.vue?vue&type=template&id=2f07b44e&"
import script from "./MRC_ESS_Form_Sections.vue?vue&type=script&lang=js&"
export * from "./MRC_ESS_Form_Sections.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})


/* hot reload */
if (module.hot) {
  var api = require("D:\\Mega\\MRC\\mrc-ess-fronted\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f07b44e')) {
      api.createRecord('2f07b44e', component.options)
    } else {
      api.reload('2f07b44e', component.options)
    }
    module.hot.accept("./MRC_ESS_Form_Sections.vue?vue&type=template&id=2f07b44e&", function () {
      api.rerender('2f07b44e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MRC_ESS_Form_Sections.vue"
export default component.exports